import React from 'react'

const Nodejs_Course_Exam = () => {
  return (
    <div>
      <h1>Node Js Course Exam</h1>
    </div>
  )
}

export default Nodejs_Course_Exam
